import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-scroll';
import { useNavigate } from 'react-router-dom';

const Nav = styled.nav`
  width: 94%;
  max-width: 1240px;
  height: 74px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.75rem;
  background: rgba(250, 246, 238, 0.8);
  backdrop-filter: blur(10px);
  position: fixed;
  top: 14px;
  left: 0;
  right: 0;
  margin: 0 auto;
  z-index: 999;
  box-shadow: var(--shadow-soft);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
`;

const Logo = styled.div`
  width: 150px;
  height: 45px;
  cursor: pointer;
  background-image: url('/images/Logo.png');
  background-size: contain;
  background-position: center left;
  background-repeat: no-repeat;
`;

const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;

  @media screen and (max-width: 900px) {
    display: ${({ isOpen }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    position: fixed;
    top: 88px;
    left: 0;
    width: 100vw;
    height: calc(100vh - 88px);
    background: var(--color-paper);
    padding-top: 2rem;
    overflow-y: auto;
  }
`;

const NavItem = styled.li`
  margin: 0 0.85rem;

  @media screen and (max-width: 900px) {
    margin: 1.25rem 0;
  }
`;

const linkStyles = `
  font-family: var(--font-body);
  color: var(--color-ink);
  font-size: 0.98rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: var(--color-accent);
  }
`;

const StyledLink = styled.a`
  ${linkStyles}
`;

const NavLink = styled(Link)`
  ${linkStyles}
`;

const NavBtn = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 900px) {
    margin: 2rem 0;
  }
`;

const Button = styled.a`
  background: var(--color-accent);
  color: var(--color-white);
  padding: 0.7rem 1.5rem;
  border-radius: var(--radius-sm);
  font-family: var(--font-body);
  font-size: 0.95rem;
  font-weight: 700;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    background: var(--color-accent-hover);
    transform: translateY(-2px);
  }
`;

const MobileIcon = styled.div`
  display: none;
  color: var(--color-brand-deep);

  @media screen and (max-width: 900px) {
    display: block;
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

const Navbar = () => {
  const router = useNavigate();

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Nav>
      <Logo onClick={() => router('/#home')} />
      <MobileIcon onClick={toggle}>
        {isOpen ? '✕' : '☰'}
      </MobileIcon>
      <NavMenu isOpen={isOpen}>
        <NavItem>
          <NavLink
            to="home"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={() => {setIsOpen(false); router('/#home')}}
          >
            Início
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            to="features"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={() => {setIsOpen(false); router('/#features')}}
          >
            Recursos
          </NavLink>
        </NavItem>
        {/* <NavItem>
          <NavLink
            to="pricing"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={() => {setIsOpen(false); router('/#pricing')}}
          >
            Preços
          </NavLink>
        </NavItem> */}
        <NavItem>
          <NavLink
            to="about"
            smooth={true}
            duration={500}
            spy={true}
            exact="true"
            offset={-80}
            onClick={() => {setIsOpen(false); router('/#about')}}
          >
            Sobre
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            to="downloads"
            onClick={() => {setIsOpen(false); router('/downloads')}}
          >
            Downloads
          </NavLink>
        </NavItem>
        <NavItem style={{marginRight: 20}}>
          <StyledLink
            href="https://ajuda.sofchef.com.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            Ajuda
          </StyledLink>
        </NavItem>
        <NavBtn>
          <Button href="https://app.sofchef.com.br" target="_blank" data-cta-id="navbar-entrar">
            Entrar
          </Button>
        </NavBtn>
      </NavMenu>
    </Nav>
  );
};

export default Navbar;
